// ===== URL パラメータから bom を保存 =====
export function saveAffFromURL() {
  try {
    const u = new URL(window.location.href);

    // ① 新仕様の bom を優先
    const bom = u.searchParams.get("bom");
    if (bom) {
      localStorage.setItem("affCode", bom);
      return;
    }

    // ② 旧仕様 aff があれば互換で保存
    const aff = u.searchParams.get("aff");
    if (aff) {
      localStorage.setItem("affCode", aff);
    }

  } catch {}
}

export function getAffCode() {
  return localStorage.getItem("affCode") || "";
}
